import { Fragment, useEffect, useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import { useTheme } from "@mui/material";

import { generalPortalRoutes } from "../../Utils/Routes/routes";
import { useNavigate, useLocation } from "react-router-dom";
import { hasSomeAuthorization } from "../../Auth/actionsCheck";
import { PathStateObject } from "../../Utils/Models/routesModel";
import Hidden from "@mui/material/Hidden";
import { shallowEqual, useSelector } from "react-redux";
import StoreStateModel from "../../Utils/Models/store";

interface Props {
  scopes: string[];
  accountFullName?: string;
  userName?: string;
}
const CreateNavLinks = ({ scopes, accountFullName, userName }: Props) => {
  const navigate = useNavigate();
  const location: any = useLocation();
  const theme = useTheme();
  const [selectedList, setSelectedList] = useState(window.location.pathname);

  const accountAssigned = useSelector(
    (state: StoreStateModel) => state.auth.accountAssigned,
    shallowEqual
  );

  useEffect(() => {
    setSelectedList(location.pathname);
  }, [location.pathname]);

  return (
    <Fragment>
      <List component="nav" aria-labelledby="nested-list-subheader">
        {generalPortalRoutes.map((route) => {
          const skipValidateAccountAssigned = route.needAccountAssigned
            ? (accountAssigned?.id as number) > 0
              ? true
              : false
            : true;
          const listItemStyle = {
            item: {
              backgroundColor: selectedList == route.path ? theme.palette.secondary.dark : "",
              borderLeft:
                selectedList == route.path ? `solid 3px ${theme.palette.primary.main}` : "none",
            },
          };
          return (
            <Fragment key={route.id}>
              {!route.skipSideBarMenu ? (
                hasSomeAuthorization(route.authorization, scopes) && skipValidateAccountAssigned ? (
                  <>
                    {route.startSidebarSection && <Divider sx={{ my: 1 }} />}
                    <ListItem
                      button
                      key={route.id + "-List"}
                      selected={selectedList == route.path}
                      onClick={() => {
                        if (selectedList == route.path) {
                          navigate(route.path, {
                            replace: true,
                            state: {
                              from: location.pathname,
                            } as PathStateObject,
                          });
                        } else {
                          navigate(route.path, {
                            state: {
                              from: location.pathname,
                            } as PathStateObject,
                          });
                        }
                      }}
                      style={listItemStyle.item}
                    >
                      <ListItemIcon
                        style={{
                          minWidth: "38px",
                          color: theme.palette.text.secondary,
                        }}
                      >
                        {<route.sideBarNavIcon />}
                      </ListItemIcon>

                      <ListItemText
                        style={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          color: theme.palette.text.secondary,
                        }}
                        primary={"" + route.textLangSidebarNav}
                      />
                    </ListItem>
                    {route.endSidebarSection && <Divider sx={{ my: 1 }} />}
                  </>
                ) : null
              ) : null}
            </Fragment>
          );
        })}
      </List>
      <Divider />
      <Hidden smUp implementation="js">
        <div>
          <List style={{ width: "100%" }} component="nav" aria-labelledby="nested-list-subheader">
            {generalPortalRoutes.map((route) => {
              return (
                <Fragment key={route.id}>
                  {route.addToSideBarMenuInMobile ? (
                    hasSomeAuthorization(route.authorization, scopes) ? (
                      <ListItem
                        button
                        key={route.id + "-List-mobile"}
                        selected={selectedList == route.path}
                        onClick={() => {
                          if (selectedList == route.path) {
                            navigate(route.path, {
                              replace: true,
                              state: {
                                from: location.pathname,
                              } as PathStateObject,
                            });
                          } else {
                            navigate(route.path, {
                              state: {
                                from: location.pathname,
                              } as PathStateObject,
                            });
                          }
                        }}
                      >
                        <ListItemIcon style={{ minWidth: "38px" }}>
                          {<route.sideBarNavIcon />}
                        </ListItemIcon>

                        <ListItemText primary={"" + route.textLangSidebarNav} />
                      </ListItem>
                    ) : null
                  ) : null}
                </Fragment>
              );
            })}
          </List>
        </div>
      </Hidden>
    </Fragment>
  );
};
export default CreateNavLinks;
